/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Stack } from '@fluentui/react';
import CardStyles from './CardStyles';
import StackTokens from './StackTokens';
import Theme from './Theme';
import Utils from './Utils';
import IconButton from './IconButton';

export default ({ dsData, header }) => {
  const ref = React.useRef();
  const [extraHeader, setExtraHeader] = React.useState();

  return (
    <Stack horizontal tokens={StackTokens.spacing}>
      <Stack>
        <table ref={ref} className={[Theme.styles.table, Theme.styles.tableNoPadding, CardStyles.prettyTable].join(' ')}>
          <thead>
            {extraHeader && (
            <tr>
              <th colSpan={5}>
                {extraHeader}
              </th>
            </tr>
            )}
            <tr>
              <th colSpan={5}>
                {`Case: ${dsData.name}`}
              </th>
            </tr>
            <tr>
              {dsData.headers.map((hdr) => (<th key={hdr}>{hdr}</th>))}
            </tr>
          </thead>
          <tbody>
            {dsData?.rows.map((row, i) => (
              <tr key={i}>
                {row.map((tdv, j) => (
                  <td key={j}>{tdv}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Stack>
      <Stack horizontal tokens={StackTokens.spacing} className="output-item-actions">
        <IconButton
          iconName="Copy"
          tooltip={`Copy table for ${dsData.name}`}
          onClick={() => {
            if (header) {
              setExtraHeader(header);
              setTimeout(() => {
                Utils.copyContentsToClipboard(ref.current);
                setTimeout(() => {
                  setExtraHeader();
                }, 10);
              }, 10);
            } else {
              Utils.copyContentsToClipboard(ref.current);
            }
          }}
        />
        <IconButton
          iconName="Download"
          tooltip={`Download as CSV table for ${dsData.name}`}
          onClick={() => {
            Utils.saveToFile(`${dsData.name}.csv`, Utils.toCsv([...[dsData.headers], ...dsData.rows]));
          }}
        />
      </Stack>
    </Stack>
  );
};
